/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

/* eslint-disable lines-between-class-members */
import { BaseEnum } from './base/BaseEnum';

export class FeeCellType extends BaseEnum {
  static CHECKBOX = new FeeCellType('checkbox');
  static TEXT = new FeeCellType('text');
  static LATEFEE = new FeeCellType('latefee');
  static BARCODE = new FeeCellType('barcode');
  static PRICE = new FeeCellType('price');
  static DISCOUNT = new FeeCellType('discount');
  static SURCHARGE = new FeeCellType('surcharge');
  static QUANTITY = new FeeCellType('quantity');
  static QUANTITYEDITABLE = new FeeCellType('quantityEditable');
  static SUBTOTAL = new FeeCellType('subtotal');
}

export const CURRENCY_POSITION_TYPE = Object.freeze({
  AFTER: 'AFTER',
  BEFORE: 'BEFORE',
});
export const CURRENCY_SYMPLE_TYPE = Object.freeze({
  DEFAULTCURRENCY: 'EUR',
});
